<template>
  <div class="complaint_details" style="padding-bottom: 2.7rem">
    <!--0是退款进度，1是投诉进度-->
    <div v-if="processType==0">
      <div class="details">
        <ul class="details_content">
          <li><span class="details_tit">商家名称:</span><span class="details_con">{{refundDetails.shopName}}</span></li>
          <li><span class="details_tit">订单号码:</span><span class="details_con">{{refundDetails.orderId}}</span></li>
          <li><span class="line"></span></li>
          <li><span class="details_tit">申请金额:</span><span class="details_con" style="color: #f2596c;">￥{{refundDetails.refundAmount}}</span></li>
          <li><span class="details_tit">申请商品:</span><span class="details_con">{{refundDetails.refundGoodsDetail}}</span></li>
          <li v-if="refundDetails.showResult==1"><span class="details_tit">退款金额:</span><span class="details_con" style="color: #F2596C;">￥{{refundDetails.realrefundAmount}}</span></li>
          <li v-if="refundDetails.showResult==1"><span class="details_tit">退款商品:</span><span class="details_con">{{refundDetails.finalRefundGoodsDesc}}</span></li>
        </ul>
      </div>
      <div class="process">
        <!--<h3>退款进度</h3>-->
        <ul class="process_content">
          <li v-for="item in refundDetails.messageList" class="clearfix">
              <div class="process_time">{{item.handleDate}}</div>
              <div class="process_box" v-if="item.title">
                  <span :class="['process_icon fl', {'active':item.selected === 1}]" ></span>
                  <span :class="['process_tit fl', {'active':item.selected === 1}]">{{item.title}}</span>
                  <!--<span class="process_time fr">{{item.handleDate}}</span>-->
              </div>
              <p class="process_des" v-html="item.refundGoodsStr"></p>
              <p class="process_des" v-html="item.message"></p>
          </li>
        </ul>
      </div>
      <div style="position: fixed;bottom:0;background: #f6f6f6;" v-if="refundDetails.showAccept==1 || refundDetails.showAppealStaus==1">

        <div class="btn-big btn-yellow" v-if="refundDetails.showAccept==1" @click="acceptResult">
          <h4>接受商家处理结果</h4>
          <p>(退款金额立即到账)</p>
        </div>

        <div class="btn-big" v-if="refundDetails.showAppealStaus==1" @click="confirmAppeal">
          <h4>退款申诉</h4>
          <p>(商家处理后72h内可发起申诉，超时将默认您接受商家处理结果)</p>
        </div>
      </div>
      <div class="btn" v-if="refundDetails.isCanCancel==1" @click="cancelComplaint">撤销退款申请</div>
      <div class="btn" v-if="refundDetails.showAppealStaus==2" @click="handleClickAppeal(2)">撤销退款申诉</div>
    </div>
    <!--投诉进度-->
    <div v-else>
      <div class="details">
        <h3 style="font-weight: bold;">投诉详情</h3>
        <ul class="details_content">
          <li><span class="details_tit">商家名称:</span><span class="details_con">{{details.supplierShortName}}</span></li>
          <li><span class="details_tit">订单号码:</span><span class="details_con">{{details.orderId}}</span></li>
          <li><span class="line"></span></li>
          <li><span class="details_tit">投诉对象:</span><span class="details_con">{{responsibleParty}}</span></li>
          <li><span class="details_tit">投诉理由:</span><span class="details_con">{{details.complainReason}}</span></li>
          <li v-if="details.compainComment!=''"><span class="details_tit">详细描述:</span><span class="details_con">{{details.compainComment}}</span></li>
          <li v-if="details.afterSaleType==1">
            <span class="details_tit">订单金额:</span><span class="details_con"><span v-show="details.realAmount!='' && details.realAmount!=null">￥</span>{{details.realAmount}}</span>
          </li>
        </ul>
        <PreviewPicture v-if="urls.length>0" class="details_pic" :previewPictures='urls'></PreviewPicture>
      </div>
      <div class="process">
        <ul class="process_content">
          <li v-for="item in details.messageList" class="clearfix">
            <div class="process_time">{{item.handleDate}}</div>
            <div class="process_box">
              <span :class ="['process_icon fl', {'active':item.selected === 1}]" ></span>
              <span :class="['process_tit fl', {'active':item.selected === 1}]">{{item.title}}</span>
              <!--<span class="process_time fr">{{item.handleDate}}</span>-->
            </div>
            <p class="process_des">{{item.message}}</p>
          </li>
        </ul>
      </div>
      <div v-if="details.afterSaleType==1">
        <div class="btn" v-if="details.canCancel==1" @click="cancelComplaint">取消投诉</div>
        <div class="btn" v-if="messageList.length >= 2 && details.resultFeedBack==0 && details.canCancel==1" @click="toFeedBack">投诉反馈</div>
      </div>
      <div v-else>
        <div class="btn" v-if="details.canCancel==1" @click="cancelComplaint">取消售后</div>
        <div class="btn" v-if="messageList.length==4 && details.resultFeedBack==0" @click="toFeedBack">售后反馈</div>
      </div>
    </div>
    <div class="appeal-alert mask" v-show="showAppealAlert">
      <div class="appeal-alert-box">
        <h3>退款申诉</h3>
        <div class="input-box">
          <textarea v-model="appealReason" placeholder="请输入申诉理由，不超过200字" maxlength="200"></textarea>
        </div>
        <div class="appeal-description">发起申诉后，您的此笔退款订单将由俺来也平台
          介入审核。期间您可能会收到俺来也平台的客服
          电话，请保持手机畅通。审核约需1-3个工作日。</div>
        <div class="appeal-btn flexrow">
          <span class="cancel" @click="showAppealAlert=false">取消</span>
          <span class="submit" @click="handleClickAppeal(1)">提交申诉</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  import PreviewPicture from "../components/PreviewPicture"
  // import { MessageBox, Toast, Indicator} from 'mint-ui'

  export default {
      data () {
         return {
            processType: window.localStorage.getItem('processType'),
            // processType: 0,
            complainId: window.localStorage.getItem('complainId'),
            orderId: window.localStorage.getItem('orderCode'),
            details: {},
            refundDetails: {},
            responsibleParty: '',
            messageList: [],
            urls: [],
            showAppealAlert: false,
            appealReason: '',//申诉理由

         }
      },
      created () {
        var _this = this
        if(_this.processType==0){
          document.title = "退款进度";
          _this.getRefundDetails()//获取退款进度

        }else if(_this.processType==1){
          document.title = "投诉进度";
          _this.getComplaintDetails()//获取投诉进度

        }

      },
      methods: {
        acceptResult() {
          var _this = this
          let params = {
            complaintId:_this.complainId
          }
          _this.$messagebox.confirm('点击确认后，我们将按照商家处理结果处理您的退款申请','').then(action => {
            actions.getRefundResult(_this, params, function (data) {
              _this.getRefundDetails()
            }, function(data){
              _this.$toast(data.body.message)
            })
          }).catch(() => {})

        },
        confirmAppeal() {
          this.showAppealAlert = true;
          this.appealReason = '';
        },
        handleClickAppeal(type){
          var _this = this
          let params = {
            complaintId:_this.complainId,
            appealStatus: type
          }
          if(type == 1){
            if(_this.appealReason != ''){
              params.appealContent = _this.appealReason
            }else{
              _this.$toast('申诉理由不能为空');
              return false;
            }
            actions.postAppeal(_this, params, function (data) {
              _this.showAppealAlert = false;
              _this.getRefundDetails()
            }, function(data){
              _this.showAppealAlert = false;
              _this.$toast(data.body.message)
            })
          }else if (type == 2){
            _this.$messagebox.confirm('撤销申诉将默认您同意商家处理意见，不可再次进行申诉。','').then(action => {
              actions.postAppeal(_this, params, function (data) {
                _this.getRefundDetails()
              }, function(data){
                _this.$toast(data.body.message)
              })
            }).catch(() => {})
          }

        },
        getRefundDetails: function (){
          var _this = this
          var params = {
            orderId: _this.orderId
          }
          actions.getRefundDetails(_this, params, function (data) {
            _this.refundDetails = data
            if(_this.refundDetails.messageList.length > 0){
              for (var i = 0;i < _this.refundDetails.messageList.length; i++) {
                if(_this.refundDetails.messageList[i].message){
                  _this.refundDetails.messageList[i].message = _this.refundDetails.messageList[i].message.replace(/\n/g,"<br>" )
                }
                // console.log(_this.refundDetails.messageList[i].message)
              }
            }
            _this.complainId = data.complaintId
          }, function(data){
            _this.$toast(data.body.message)
          })
        },
        getComplaintDetails: function (){
            var _this = this
            var params = {
               complainId: _this.complainId
            }
            actions.getComplaintDetails(_this, params, function (data) {
              _this.details = data
              _this.urls = _this.details.urls
              _this.messageList = _this.details.messageList
              //_this.details.messageList.reverse() //逆转售后流程数组
              if(_this.details.responsibleCode == 1000) {
                _this.responsibleParty = '商家'
              } else if (_this.details.responsibleCode == 2000) {
                _this.responsibleParty = '西游侠'
              } else if (_this.details.responsibleCode == 3000) {
                _this.responsibleParty = '平台'
              }
            }, function(data){
              _this.$toast(data.body.message)
            })
        },
        toFeedBack: function (){
          window.localStorage.setItem('complainId', this.complainId),
          this.$router.push({name:'FeedBack'})
        },
        // 取消投诉、取消退款申请
        cancelComplaint: function () {
          var _this = this
          var params = {
            complainId: _this.complainId
          }
          if (_this.processType==0){
            _this.$messagebox.confirm('撤销后无法再申请,确定撤销本次退款申请吗？','').then(action => {
              actions.getCancelComplaint(_this, params, function (data) {
                //反馈成功
                _this.$messagebox.alert('撤销成功','')
                _this.getRefundDetails()
              }, function (data) {
                _this.$toast(data.body.message)
                _this.getRefundDetails()
                //错误返回
              })
            }).catch(() => {})
          } else if (_this.processType==1) {
            _this.$messagebox.confirm('取消后将无法再申请,已经得到满意答复？','').then(action => {
              actions.getCancelComplaint(_this, params, function (data) {
                //反馈成功
                _this.$messagebox.alert('取消成功','')
                _this.getComplaintDetails()
              }, function (data) {
                _this.$toast(data.body.message)
                _this.getComplaintDetails()
                //错误返回
              })
            }).catch(() => {})
          }

        }
      },
      components: {
        PreviewPicture
      }
  }
</script>



// WEBPACK FOOTER //
// CheckComplaints.vue?2d15e0d1